import clsx from 'clsx';
import InterviewActionsCombobox from 'components/comboboxes/InterviewActionsCombobox';
import { CircleMinus } from 'lucide-react';
import type { ComponentProps } from 'react';
import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';
import { removeActionFromOption, updateActionInOption } from 'rtk/Question.Editor.Slice';
import { selectQuestionLanguage } from 'rtk/questionEditorSelector';
import { toast } from 'sonner';
import { useQuestionEditorContext } from '../context/create-question.context';

interface Props extends ComponentProps<'div'> {
  action: string;
  fieldIndex: number;
  itemIndex: number;
}

const OptionAction = ({ action, fieldIndex, itemIndex, ...props }: Props) => {
  const dispatch = useAppDispatch();
  const { questionId } = useQuestionEditorContext();
  const questionLanguage = useAppSelector((state) => selectQuestionLanguage(state, questionId));
  const errors = useAppSelector((state) => state.questionEditor.byId[questionId].optionsErrors);
  if (errors?.length) errors.map((x) => toast.error(x));
  return (
    <div
      {...props}
      className={clsx(
        'flex flex-row justify-between gap-4',
        'h-[44px]',
        'hubert-vertical-center',
        'px-4 py-4',
        'hover:bg-neutral-purple',
        'rounded-sm',
      )}
    >
      <InterviewActionsCombobox
        id={`create-question-interview-post-action-${fieldIndex}`}
        isMulti={false}
        onValueChange={(value) => {
          dispatch(
            updateActionInOption({
              questionId,
              optionIndex: fieldIndex,
              actionIndex: itemIndex,
              value: value as string,
              language: questionLanguage,
            }),
          );
        }}
        value={action}
      />

      <div className={clsx('flex flex-row justify-between gap-4')}>
        <CircleMinus
          onClick={() => {
            dispatch(
              removeActionFromOption({
                questionId,
                optionIndex: fieldIndex,
                actionIndex: itemIndex,
                language: questionLanguage,
              }),
            );
          }}
        />
      </div>
    </div>
  );
};

export default OptionAction;
